export class GetAvailableTimesParameter
{
    public categoryId: number;
    public day: Date;

    constructor(categoryId: number, day: Date) {
        this.categoryId = categoryId;
        this.day = day;
    }
}